import React from 'react';
import PropType from 'prop-types';
import { Link } from 'react-router-dom';

const FormDetailsLink = ({
  label, value, href,
}) => (
  <div className="row">
    <div className="col col-md-3">
      <label className="form-control-label">{label}</label>
    </div>
    <Link to={href} className="form-detail-link">
      {value}
    </Link>
  </div>
);

FormDetailsLink.defaultProps = {
  value: '',
};

FormDetailsLink.propTypes = {
  label: PropType.string.isRequired,
  value: PropType.oneOfType([PropType.any]),
  href: PropType.string.isRequired,
};

export default FormDetailsLink;
